import React from 'react';

import { wrongSKUsErrorMessage } from '../../campaign-editor/constants';
import ErrorComponent from '../Error';
import SuccessComponent from '../Success';
import WarningComponent from '../Warning';
import { flash } from './actions';

export const flashError = error =>
  flash(
    <ErrorComponent
      error={error}
      className="mb-0 white-space-pre-wrap"
      component="div"
    />,
    'danger',
    0,
  );

export const flashSuccess = success =>
  flash(
    <SuccessComponent
      success={success}
      className="mb-0 white-space-pre-wrap"
      component="div"
    />,
    'success',
    0,
  );

export const flashWarning = warning =>
  flash(
    <WarningComponent
      warning={warning}
      className="mb-0 white-space-pre-wrap"
      component="div"
    />,
    'warning',
    180,
    true,
  );

export const tapFlashSuccess = (dispatch, message) => value => {
  dispatch(flash(message, 'success'));
  return value;
};

export const tapFlashWarning = (dispatch, warning) => {
  dispatch(flashWarning(warning));
  return warning;
};

export const wrongSKUsError = error =>
  error?.response?.data?.campaignLines?.[0]?.highlightedSkus?.[0] ||
  error?.response?.data?.highlightedSkus ||
  '';

export const tapFlashError = (dispatch, customMessage) => error => {
  if (wrongSKUsError(error).includes(wrongSKUsErrorMessage)) {
    throw error;
  }
  if (customMessage) {
    // Create an enhanced error with the custom message and original error details
    const enhancedError = {
      ...error,
      message: customMessage,
      data: error?.response?.data || error?.data,
    };
    dispatch(flashError(enhancedError));
  } else {
    dispatch(flashError(error));
  }
  throw error;
};

// This uses the error message sent from the BE itself
export const tapFlashSuccessWithCustomMessage = dispatch => success => {
  dispatch(flashSuccess(success));
  return success;
};

export const parseSKUs = errorMessage => {
  const findSKUsArrayRegex = /(\[.*?\])/;
  const matchResult = errorMessage.match(findSKUsArrayRegex);

  if (matchResult && matchResult[1]) {
    const arrayString = matchResult[1];
    const jsonReadyString = arrayString.replace(/'/g, '"');

    const parsedArray = JSON.parse(jsonReadyString);
    return Array.isArray(parsedArray) ? parsedArray : undefined;
  }
  return undefined;
};
